import { RESET } from '../actionTypes';
import { credentialIntegrationsActions } from '../reducer';

export default () => credentialIntegrationsActions[RESET]();
